export const PRODUCTS = 'products'
export const RECO = 'reco'
export const RECO_TYPE = 'reco-type'
export const RECO_SEARCH = 'reco-search'
